import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import { threadList, follow, unFollow, followList } from '@/api/mg';
var threadListParams = {
  perPage: 1000,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0
};
export default {
  data: function data() {
    return {
      userId: '',
      title: '',
      name: '',
      nickname: '',
      leftIcon: require('../../assets/images/Search.png'),
      clubData: [],
      followList: []
    };
  },
  created: function created() {
    this.userId = localStorage.getItem('userId');
    this.name = this.$route.query.str;
    this.toUserId = this.$route.query.toUserId;
    if (this.userId === this.toUserId) {
      this.title = 'My ' + this.name;
    } else {
      this.title = this.name;
    }
    threadListParams.page = 1;
    threadListParams['filter[sort]'] = 1;
    if (this.name === 'Works') {
      threadListParams['filter[toUserId]'] = this.toUserId;
      threadListParams['filter[complex]'] = 5;
      this.getThreadList(threadListParams);
    }
    if (this.name === 'Favorites') {
      threadListParams['filter[toUserId]'] = this.toUserId;
      threadListParams['filter[complex]'] = 3;
      this.getThreadList(threadListParams);
    }
    var params = {
      page: 1,
      perPage: 1000
    };
    if (this.name === 'Follow') {
      params['filter[userId]'] = this.toUserId;
      params['filter[type]'] = 1;
      params['filter[nickName]'] = this.nickname;
      this.getFollowList(params);
    }
    if (this.name === 'Fans') {
      params['filter[userId]'] = this.toUserId;
      params['filter[type]'] = 2;
      params['filter[nickName]'] = this.nickname;
      this.getFollowList(params);
    }
  },
  methods: {
    toMe: function toMe(pid) {
      this.$router.push({
        path: '/others',
        query: {
          pid: pid
        }
      });
    },
    input: function input() {
      var params = {
        page: 1,
        perPage: 1000
      };
      if (this.name === 'Follow') {
        params['filter[userId]'] = this.toUserId;
        params['filter[type]'] = 1;
        params['filter[nickName]'] = this.nickname;
        this.getFollowList(params);
      }
      if (this.name === 'Fans') {
        params['filter[userId]'] = this.toUserId;
        params['filter[type]'] = 2;
        params['filter[nickName]'] = this.nickname;
        this.getFollowList(params);
      }
    },
    toDetail: function toDetail(threadId, categoryName) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: categoryName.toLowerCase(),
          threadId: threadId
        }
      });
    },
    getFollowList: function getFollowList(params) {
      var _this = this;
      followList(params).then(function (res) {
        if (res.Code === 0) {
          _this.followList = res.Data.pageData;
          if (!_this.followList) {
            _this.$toast('empty');
          }
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    getThreadList: function getThreadList(params) {
      var _this2 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.pageData.length === 0) {
            _this2.$toast('empty');
          }
          _this2.totalPage = res.Data.totalPage;
          _this2.clubData = [].concat(_toConsumableArray(_this2.clubData), _toConsumableArray(res.Data.pageData));
          _this2.loading = false;
          _this2.isLoading = false;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    back: function back() {
      this.$router.back();
    },
    toFollow: function toFollow(userId, item) {
      var _this3 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          var _params = {
            page: 1,
            perPage: 10
          };
          if (_this3.name === 'Follow') {
            _params['filter[userId]'] = _this3.toUserId;
            _params['filter[type]'] = 1;
            _this3.getFollowList(_params);
          }
          if (_this3.name === 'Fans') {
            _params['filter[userId]'] = _this3.toUserId;
            _params['filter[type]'] = 2;
            _this3.getFollowList(_params);
          }
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId, item) {
      var _this4 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          var _params2 = {
            page: 1,
            perPage: 10
          };
          if (_this4.name === 'Follow') {
            _params2['filter[userId]'] = _this4.toUserId;
            _params2['filter[type]'] = 1;
            _this4.getFollowList(_params2);
          }
          if (_this4.name === 'Fans') {
            _params2['filter[userId]'] = _this4.toUserId;
            _params2['filter[type]'] = 2;
            _this4.getFollowList(_params2);
          }
        } else {
          _this4.$toast(res.Message);
        }
      });
    }
  }
};